export default __webpack_public_path__ + "static/media/valley8.308f0ac3.png";